import dayjs from 'dayjs'
import React, { useCallback, useState } from 'react'
import { Button, Popconfirm } from 'antd'
import { ButtonActionWrapper } from '../../components/list-operations/styles'
import { DeleteTwoTone } from '@ant-design/icons'
import { getCall } from '../../components/v2/activity-timeline/api/getCall'
import { DataType } from './interface'
import { formatPhoneNumber } from '../orders/list/columns'
import { Link } from 'react-router-dom'

const secondsToHumanReadable = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return dayjs().set('minute', minutes).set('second', remainingSeconds).format('m:ss')
}

const ColumnId: any[] = []

const ColumnsGeneral: any[] = [
  {
    title: 'Дата',
    dataIndex: 'date',
    key: 'date',
    width: 160,
    render: (date: string) => dayjs(date).format('DD.MM.YYYY HH:mm:ss'),
  },
  {
    title: 'Откуда',
    dataIndex: 'from_number',
    key: 'from_number',
    width: 180,
    render: (value: string) => formatPhoneNumber(value),
  },
  {
    title: 'Номер Манго',
    dataIndex: 'line_number',
    key: 'line_number',
    width: 180,
    render: (value: string) => formatPhoneNumber(value),
  },
  {
    title: 'ФИО контакта',
    dataIndex: 'customer',
    key: 'customer',
    width: 180,
    render: (customer: string, row: DataType) =>
      row.customer_id ? (
        <Link
          to={
            row.customer_type === 'hr'
              ? `/hr/${row.customer_id}`
              : row.customer_type === 'delivery'
              ? `/logistics/deliveries/${row.customer_id}`
              : `/client-new/${row.customer_id}`
          }
        >
          {customer}
        </Link>
      ) : (
        customer
      ),
  },
  {
    title: 'Бренд',
    dataIndex: 'brand',
    key: 'brand',
    width: 120,
  },
  {
    title: 'Офис',
    dataIndex: 'office',
    key: 'office',
    width: 160,
  },
  {
    title: 'Менеджер',
    dataIndex: 'manager',
    key: 'manager',
    width: 200,
  },
  {
    title: 'Статус',
    dataIndex: 'call_direction',
    key: 'call_direction',
    width: 170,
    render: (direction: string, row: DataType) => (
      <>
        {direction},{' '}
        <span style={{ color: row.state === 'пропущен' ? '#dc0000' : 'inherit' }}>{row.state}</span>
      </>
    ),
  },
  {
    title: 'Продолжительность',
    dataIndex: 'duration',
    key: 'duration',
    width: 160,
    render: (duration: number) => secondsToHumanReadable(duration),
  },
  {
    title: 'Запись',
    dataIndex: 'records',
    key: 'records',
    render: (records: null | string[], row: DataType) => {
      if (records && records.length) {
        return <LoadButtonAndPlayer rowId={row.id} />
      }
      return null
    },
  },
]

export function DeleteButton({ id, deleteRecord }) {
  const localDeleteRecord = useCallback(() => deleteRecord(id), [deleteRecord, id])
  return (
    <Popconfirm
      title="Вы уверены, что хотите удалить эту запись?"
      okText="Да"
      cancelText="Нет"
      onConfirm={() => localDeleteRecord()}
    >
      <ButtonActionWrapper title="Удалить">
        <DeleteTwoTone />
      </ButtonActionWrapper>
    </Popconfirm>
  )
}

export const getColumns = (isGoLeader, isBrandLeader, sorter) => {
  let columns = ColumnId.concat(ColumnsGeneral)

  columns = columns.filter(col => {
    if (isBrandLeader && col.key === 'brand') return false
    if (!isBrandLeader && !isGoLeader && (col.key === 'brand' || col.key === 'office')) return false
    return true
  })

  return columns.map(item => ({
    ...item,
    sortOrder: item.key === sorter.sort_field ? sorter.sort_order : undefined,
  }))
}

function LoadButtonAndPlayer({ rowId }) {
  const [calls, setCalls] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const handleLoadCall = useCallback(() => {
    const id = rowId
    if (!id) return
    setIsLoading(true)
    getCall(id)
      .then(response => {
        if (response && response?.length) {
          setCalls(response as string[])
        }
      })
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <div style={{ minWidth: 200, display: 'flex', justifyContent: 'center' }}>
      {!isLoading && calls.length > 0 ? (
        <div style={{ width: '100%', display: 'flex', margin: '1px 0' }}>
          {calls.map((call, index) => (
            <audio key={index} controls style={{ width: '100%', height: '30px' }}>
              <source src={call} type="audio/mpeg" />
            </audio>
          ))}
        </div>
      ) : (
        <Button type="default" onClick={handleLoadCall} loading={isLoading}>
          Загрузить звонок
        </Button>
      )}
    </div>
  )
}
